import { translate } from '@jsverse/transloco';
export enum ConnectionStatus {
    CONNECTED = 'CONNECTED',
    POTENTIALLY_DISCONNECTED = 'POTENTIALLY_DISCONNECTED',
    DISCONNECTED = 'DISCONNECTED',
    NEVER = 'NEVER',
}

export class ConnectionStatusHelper {
    static getConnectionStatusLocale(connectionStatus: ConnectionStatus): string {
        switch (connectionStatus) {
            case ConnectionStatus.CONNECTED:
                return translate('CORE.CONNECTION_STATUS.CONNECTED');
            case ConnectionStatus.POTENTIALLY_DISCONNECTED:
                return translate('CORE.CONNECTION_STATUS.POTENTIALLY_DISCONNECTED');
            case ConnectionStatus.DISCONNECTED:
                return translate('CORE.CONNECTION_STATUS.DISCONNECTED');
            case ConnectionStatus.NEVER:
                return translate('CORE.CONNECTION_STATUS.NEVER');
            default:
                return '';
        }
    }
}
